import  { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getCreditCardProcessingPurchaseResponceApi } from '@common/api/api';
import { getClientPlatformForAPI, getErrorMessage } from '../config/utils';

const POLL_INTERVAL = 1000;
const PollUserCreditStatus = ({ id, onChange }) => {
  const doPoll = () => {
    getCreditCardProcessingPurchaseResponceApi(id, { platform: getClientPlatformForAPI() }).then(response => {
      const { errorMessage, okMessage } = response;
      // TODO: parse and handle response fields
      if (errorMessage || okMessage) {
        onChange(!!okMessage, response);
        return;
      }
      setTimeout(doPoll, POLL_INTERVAL);
    }).catch((error) => {
      getErrorMessage(error).then(errorMessage => {
        if (errorMessage === 'Failed to fetch') {
          setTimeout(doPoll, POLL_INTERVAL);
          return;
        }
        onChange(false, { errorMessage });
      }).catch((err) => {
        if (err === 'Failed to fetch') {
          setTimeout(doPoll, POLL_INTERVAL);
          return;
        }
        onChange(false, { errorMessage: err });
      });
    });
  };

  useEffect(() => {
    doPoll();
  }, []);

  return null;
};

PollUserCreditStatus.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default PollUserCreditStatus;
